<template>
  <section class="mission animate-box">
    <div class="container">
      <div class="section-tag">MISSION</div>
      <h2>科技与人文的<span>深度共鸣</span></h2>
      <div class="grid">
        <div class="glass-card">
          <div class="icon">01</div>
          <h3>先锋视野</h3>
          <p>我们关注AI、量子计算与Web3，在不断变迁的时代寻找确定性。</p>
        </div>
        <div class="glass-card active">
          <div class="icon">02</div>
          <h3>智慧交互</h3>
          <p>打破沟通壁垒，让每一份灵感都能在“来秋”的社区中激荡出火花。</p>
        </div>
        <div class="glass-card">
          <div class="icon">03</div>
          <h3>数字美学</h3>
          <p>我们相信代码是有温度的，设计是科技的外衣，简约而不简单。</p>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.mission {
  padding: 100px 10%;
}

.section-tag {
  color: var(--accent);
  font-weight: bold;
  margin-bottom: 1rem;
}

h2 {
  font-size: 3rem;
  margin-bottom: 4rem;
}

.grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
}

.glass-card {
  background: var(--glass);
  padding: 3rem 2rem;
  border: 1px solid var(--border);
  transition: transform 0.4s;
}

.glass-card:hover {
  transform: translateY(-10px);
  background: rgba(255, 255, 255, 0.08);
}

.icon {
  font-size: 0.8rem;
  margin-bottom: 2rem;
  opacity: 0.5;
}

@media (max-width: 768px) {
  .grid {
    grid-template-columns: 1fr;
  }
}
</style>